var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPacificCommunity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003da5",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00aec7",
    d: "M15.55 15.01c-1.84.2-2.8.15-2.8.15l.3.06c.41.09.94.2 2.03.17 1.38-.03 4.02-.36 5.03-.5s3.45-.09 3.45-.09a17 17 0 0 0-3.4-.3c-.93.03-1.79.14-2.76.28q-.84.12-1.85.23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00aec7",
    d: "M13.59 14c-2.31.45-4.87-.23-4.87-.23a18 18 0 0 0 2.75-7.64c5.03 2.65 9.83 7.66 9.83 7.66s-1.23-.3-2.4-.28h-.06c-1.16 0-2.69 0-5.25.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00aec7",
    d: "M20.9 15.46a7.15 7.15 0 0 1-7.2 3.74l-.1.8a7.95 7.95 0 0 0 8-4.16z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15.22 4 .1.42.43.03-.37.22.1.42-.32-.28-.37.22.16-.4-.32-.27.43.03z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.98 5.17.06-.42-.3.3-.39-.17.2.37-.28.31.42-.07.2.37.06-.43.42-.08z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m20.4 6.44-.2.37.3.3-.42-.06-.2.37-.06-.42-.42-.07.38-.2-.06-.41.3.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.03 8.85-.32.28.17.4-.37-.22-.32.28.09-.41-.36-.22.42-.05.09-.41.17.39z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.3 11.83.4-.15-.41-.11-.03-.43-.23.36-.41-.11.26.33-.23.36.4-.15.27.33z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.64 13.14-.42.07-.05.43-.2-.37-.43.08.3-.31-.2-.38.38.18.29-.31-.05.43z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m6.53 13.3.38-.18-.06-.43.3.3.38-.18-.2.37.3.31-.42-.07-.2.38-.06-.42z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.12 10.45.37-.22-.42-.03-.1-.42-.17.4-.42-.04.32.28-.17.4.37-.23.32.28z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.3 5.48-.14.41.35.25h-.43l-.12.41-.14-.4h-.42l.34-.26-.14-.4.35.25z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.06 7.9.27-.33-.42.11-.24-.35-.01.43-.41.11.4.15-.02.43.27-.34.4.15z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m12.56 4.65-.23-.36-.02.43-.4.12.4.14-.02.43.26-.33.4.14-.24-.35.27-.34z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.76 4.02.17.39.43-.04-.32.28.17.4-.37-.22-.32.28.1-.42-.38-.21.43-.05z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.07 5.83-.35-.25.13.4-.34.27.43-.01.14.4.13-.4h.42l-.35-.26.13-.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m7.73 7.7.42.12.23-.36.02.43.42.1-.4.16.02.42-.27-.32-.4.15.23-.36z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.02 6.74-.39-.19.2.38-.28.31.41-.08.21.37.06-.42.41-.08-.38-.18.05-.42z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.97 4.82.3.3.38-.18-.2.38.3.3-.42-.07-.2.38-.07-.43-.42-.07.39-.19z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.68 4.67-.02-.42-.23.35-.42-.1.27.33-.23.35.4-.14.27.32-.02-.42.4-.16z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m6.62 10.4.43-.04.09-.42.17.39.43-.05-.32.29.17.39-.37-.21-.32.28.09-.42z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m6.85 11.73-.4.11.4.15-.02.43.26-.34.4.15-.23-.36.26-.33-.41.12-.24-.36z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m7.46 16.06.3-.31-.21-.38.39.18.29-.3-.05.41.38.19-.42.08-.05.42-.2-.37z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.47 17.92-.16.39.36-.22.33.27-.1-.41.36-.23-.42-.03-.1-.42-.17.4-.42-.03z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m8.28 17.27.24-.36-.28-.33.42.1.23-.35.02.42.41.11-.4.16.04.42-.28-.33z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m7.21 14.47-.34.25h.43l.14.4.12-.4H8l-.35-.26.13-.4-.34.25-.35-.25z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m7.06 9 .42.04.17-.4.1.42.42.03-.36.22.1.42-.33-.28-.36.23.16-.4z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.6 18.73-.1.42.32-.28.37.2-.17-.38.31-.28-.42.03-.17-.38-.1.42-.42.04z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m11.82 19.77.02-.43-.4-.15.4-.12.02-.42.24.35.41-.12-.26.34.24.35-.4-.14z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.9 13.85c2.55.01 3.81.58 3.81.58a16 16 0 0 0-4.19-.13c-.63.03-1.5.15-2.4.28-1.5.2-3.13.42-4.02.34-1.44-.13-2.79-.58-2.79-.58a13 13 0 0 0 2.83.19c.66 0 1.56-.13 2.57-.28a29 29 0 0 1 4.19-.4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.71 9.88s-.07-.27-.42-.23c0 0 .23-.1.33-.05s.12.07.1.28m-.85-.48s.08-.02.12-.01c0 0 .04.16.15.22 0 0-.19-.01-.27-.2m1.12.25a.6.6 0 0 0-.44-.24c-.09 0-.3.18-.3.18-.05-.1-.03-.17-.03-.17q.17.03.19.05-.08-.2-.1-.19c.2-.05.44.13.44.13a.8.8 0 0 0-.55-.35c-.06 0-.13.08-.13.08-.4 0-.5.22-.5.22.16.26.5.32.5.32-.59-.07-.58.4-.58.4l.55-.29c-.21 1.2-1.05 1.75-1.12 1.82q-.1.13.07.16c.06 0 .13.04.31-.17q.69-.77.82-1.78l.02.02c.05.14.01.27.02.36.02.1.22.3.22.3s.12-.22.1-.36-.27-.37-.27-.37c.39-.08.41.58.41.58.15-.18.12-.37.12-.37s.31-.23.24-.32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacificCommunity);
export default __webpack_public_path__ + "static/media/pacific-community.9b7bb739be78eb178a166a8b021707b8.svg";
export { ForwardRef as ReactComponent };